import { render, staticRenderFns } from "./ExtraTable.vue?vue&type=template&id=2de5c5b1&scoped=true"
import script from "./ExtraTable.vue?vue&type=script&lang=ts"
export * from "./ExtraTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5c5b1",
  null
  
)

export default component.exports